var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.diff >= 0)?_c('span',[_vm._v(_vm._s(_vm.dayDisplayString)+" "+_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))]):_c('span',[_vm._v("EXPECTED")])}
var staticRenderFns = []

export { render, staticRenderFns }